import type {AgentInfo} from '../types/session'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import {useQuery} from '@github-ui/react-query'

export function useTopLevelAgents(nwo?: string) {
  const query = useQuery<AgentInfo[]>({
    enabled: Boolean(nwo),
    queryKey: ['top-level-agents', nwo],
    queryFn: async () => {
      try {
        if (!nwo) {
          return []
        }

        const response = await verifiedFetchJSON(`/copilot/agent-sessions/${nwo}/agents`)
        if (!response.ok) {
          return []
        }

        const data = await response.json()
        return (data.agents as AgentInfo[]) || []
      } catch {
        return []
      }
    },
    // The set of agents available in a repo is stable reference data that only
    // changes when an admin installs/removes an integration (days/weeks scale).
    // A 5-minute window eliminates refetch churn across editor remounts during
    // a single review session while still picking up changes on a fresh load.
    staleTime: 5 * 60 * 1000,
  })

  return query
}
